import styled from "styled-components";

export const SearchBarBox = styled.input`
	height: 1.5rem;
	border-radius: 20px;
	border: solid black 2px;
	box-shadow: 1px 2px #000000;
	background: transparent;
	font-family: "Anonymous Pro", monospace;
	margin-right: 1rem;
`;
export const SearchBarBtn = styled.input`
	height: 1.5rem;
	border-radius: 20px;
	border: solid black 2px;
	box-shadow: 3px 5px #000000;
	background: #eccf6e;
	padding: 0.3rem;
	font-family: "Anonymous Pro", monospace;
`;
